module.exports = __webpack_public_path__ + "fonts/BonvenoCF-Light-webfont510c73b6578922bc8650e966742f3dad.woff]";